<div class="vc-admin vc-view-shell">
  <main class="vc-admin__layout vc-view-content">
    <section class="vc-admin__frame vc-surface-panel">
      <header class="vc-admin__header">
        <div class="vc-admin__header-main">
          <h2 class="vc-admin__title">{{ "ADMIN.WORKSPACE.TITLE" | translate }}</h2>
          <p class="vc-admin__subtitle">{{ "ADMIN.WORKSPACE.SUBTITLE" | translate }}</p>
        </div>

        <div class="vc-admin__customer">
          <span class="vc-admin__customer-label">
            {{ "ADMIN.WORKSPACE.CUSTOMER" | translate }}
          </span>
          <strong class="vc-admin__customer-name">
            {{
              customerName
                ? customerName
                : ("ADMIN.WORKSPACE.DEFAULT_CUSTOMER" | translate)
            }}
          </strong>
        </div>
      </header>

      <div class="vc-admin__workspace">
        <aside class="vc-admin__nav">
          @for (group of sectionGroups; track group.id) {
            <section class="vc-admin__nav-group">
              <h3>{{ group.titleKey | translate }}</h3>
              <ul>
                @for (item of group.items; track item.id) {
                  @if (canShowItem(item)) {
                    <li>
                      <a
                        [routerLink]="toRouterLink(item)"
                        [class.vc-admin__nav-link--active]="isActive(item)"
                      >
                        <i [class]="item.icon"></i>
                        <span>{{ item.labelKey | translate }}</span>
                      </a>
                    </li>
                  }
                }
              </ul>
            </section>
          }
        </aside>

        <div class="vc-admin__content">
          <div class="vc-admin__mobile-nav">
            @for (group of sectionGroups; track group.id) {
              @for (item of group.items; track item.id) {
                @if (canShowItem(item)) {
                  <a
                    [routerLink]="toRouterLink(item)"
                    [class.vc-admin__mobile-nav-item--active]="isActive(item)"
                  >
                    <i [class]="item.icon"></i>
                    <span>{{ item.labelKey | translate }}</span>
                  </a>
                }
              }
            }
          </div>

          <div class="vc-admin__content-inner vc-admin-content-scope">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </section>
  </main>
</div>
